import { render, staticRenderFns } from "./EditorMediaBlock.vue?vue&type=template&id=607076ac&scoped=true"
import script from "./EditorMediaBlock.vue?vue&type=script&lang=js"
export * from "./EditorMediaBlock.vue?vue&type=script&lang=js"
import style0 from "./EditorMediaBlock.vue?vue&type=style&index=0&id=607076ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607076ac",
  null
  
)

export default component.exports